// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_BuscaPorNomeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /clientes/busca_por_nome
 *
 * Autocomplete search for clients by name, filtered by franchise.
 */
import { registerContract } from './validate'

export interface Clientes_BuscaPorNomeInput {
franchise_id: number
q?: string
}

registerContract('Clientes_BuscaPorNomeInput', {
  franchise_id: { type: 'number',  required: true },
  q:            { type: 'string',  required: false },
})
